import { createClient } from '@supabase/supabase-js';
import { env } from './env';

/**
 * Browser client with the publishable key only. Customers never sign in; owners sign
 * in with email + password (session kept in localStorage by supabase-js and removed
 * on sign-out). The service key and the LLM key never reach the browser.
 */
export const supabase = createClient(
  env.VITE_SUPABASE_URL || 'http://invalid.localhost',
  env.VITE_SUPABASE_PUBLISHABLE_KEY || 'missing-key',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: false,
      storageKey: 'plansgx-owner-session',
    },
    global: { headers: { 'x-client-info': 'plansgx-web' } },
  },
);
